(ns frontend.ux-overhaul.listing.real-estate.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.view.entity :as entity]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::create-real-estate
 (fn [_ _]
   (entity/open-creator! :entity.type/real-estate {})
   {}))

(rf/reg-event-fx
 ::open-bulk-edit
 (fn [_ [_ {:keys [listing-id]}]]
   (rf/dispatch [::bulk-actions/open-bulk-edit {:listing-id listing-id}])
   {}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :real-estate/mass-action
     :body-fn   (fn [ids]
                  {:action          :delete-real-estates
                   :real-estate-ids ids})})
   {}))

(rf/reg-event-fx
 ::export-grid
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id  listing-id
                               :entity-type :entity.type/real-estate})
   {}))

(rf/reg-event-fx
 ::export-grid-with-persons
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id                   listing-id
                               :entity-type                  :entity.type/real-estate
                               :include-associated-persons? true})
   {}))
